import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/congratulation-large.mp4")